// ------- Right-Arrow-Icon ------- //
export const RightArrowIcon = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    className={className}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M16.5 16.5L19.7929 13.2071C20.1834 12.8166 20.1834 12.1834 19.7929 11.7929L16.5 8.5M19.5 12.5L5.5 12.5"
      stroke="currentcolor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

// ------- Shop-Icon ------- //
export const ShopIcon = ({ className="", size = 20 }) => (

  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3204_74381)">
      <path
        d="M15.4286 20H4.28571C1.92857 20 0 18.0714 0 15.7143V15.5714L0.428571 4.14286C0.5 1.78571 2.42857 0 4.71429 0H15C17.2857 0 19.2143 1.78571 19.2857 4.14286L19.7143 15.5714C19.7857 16.7143 19.3571 17.7857 18.5714 18.6429C17.7857 19.5 16.7143 20 15.5714 20H15.4286ZM4.71429 1.42857C3.14286 1.42857 1.92857 2.64286 1.85714 4.14286L1.42857 15.7143C1.42857 17.2857 2.71429 18.5714 4.28571 18.5714H15.5714C16.3571 18.5714 17.0714 18.2143 17.5714 17.6429C18.0714 17.0714 18.3571 16.3571 18.3571 15.5714L17.9286 4.14286C17.8571 2.57143 16.6429 1.42857 15.0714 1.42857H4.71429Z"
        fill="currentcolor"
      />
      <path
        d="M9.85742 8.56975C7.07171 8.56975 4.85742 6.35547 4.85742 3.56975C4.85742 3.14118 5.14314 2.85547 5.57171 2.85547C6.00028 2.85547 6.28599 3.14118 6.28599 3.56975C6.28599 5.56975 7.85742 7.14118 9.85742 7.14118C11.8574 7.14118 13.4289 5.56975 13.4289 3.56975C13.4289 3.14118 13.7146 2.85547 14.1431 2.85547C14.5717 2.85547 14.8574 3.14118 14.8574 3.56975C14.8574 6.35547 12.6431 8.56975 9.85742 8.56975Z"
        fill="currentcolor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3204_74381">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
// ------- Close-Icon ------- //
export const CloseIcon = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4653_169979)">
      <path
        d="M0.781396 16.5001C0.626858 16.5001 0.475783 16.4543 0.347281 16.3685C0.218778 16.2826 0.118621 16.1606 0.0594776 16.0178C0.000334661 15.8751 -0.0151369 15.718 0.0150198 15.5664C0.0451766 15.4148 0.119607 15.2756 0.228896 15.1664L14.6664 0.728853C14.8129 0.582321 15.0117 0.5 15.2189 0.5C15.4261 0.5 15.6249 0.582321 15.7714 0.728853C15.9179 0.875385 16.0003 1.07413 16.0003 1.28135C16.0003 1.48858 15.9179 1.68732 15.7714 1.83385L1.3339 16.2714C1.26141 16.344 1.17528 16.4016 1.08047 16.4408C0.985653 16.4801 0.884016 16.5002 0.781396 16.5001Z"
        fill="currentcolor"
      />
      <path
        d="M15.2189 16.5001C15.1162 16.5002 15.0146 16.4801 14.9198 16.4408C14.825 16.4016 14.7388 16.344 14.6664 16.2714L0.228853 1.83385C0.0823209 1.68732 0 1.48858 0 1.28135C0 1.07413 0.0823209 0.875385 0.228853 0.728853C0.375385 0.582321 0.574125 0.5 0.781353 0.5C0.988581 0.5 1.18732 0.582321 1.33385 0.728853L15.7714 15.1664C15.8806 15.2756 15.9551 15.4148 15.9852 15.5664C16.0154 15.718 15.9999 15.8751 15.9408 16.0178C15.8816 16.1606 15.7815 16.2826 15.653 16.3685C15.5245 16.4543 15.3734 16.5001 15.2189 16.5001Z"
        fill="currentcolor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4653_169979">
        <rect
          width={16}
          height={16}
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
